import styled from "styled-components";
import { Layout, Typography, Divider, Button } from "antd";

const { Text } = Typography;

const { Content } = Layout;

// พื้นที่เนื้อหาของทุกหน้า (ContentLayout): ไม่มีพื้น ไม่มีกรอบ การ์ดของแต่ละส่วนวางบนพื้น #f8fafc เลยแบบ SIS
const StyledContent = styled(Content)`
  background: transparent;
`;

// กล่องข้อมูลแบบอ่านอย่างเดียว (หน้า detail) แบบ SIS: พื้น slate-50 ขอบ slate-100 มุม 12px
const StyledSearchForm = styled.div`
  background: var(--bg);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 20px 24px;
  margin: 0 0 24px;
  font-size: 14px;
`;

// การ์ดของหน้าฟอร์ม / รายละเอียด: ไม่มีการ์ดครอบทั้งหน้าแล้ว ฟอร์มจึงเป็นการ์ดของตัวเอง ขาว ขอบ slate-200 มุม 12px padding 24px
const GeneralStyledContent = styled(Layout.Content)`
  background: var(--surface) !important;
  border: 1px solid var(--border);
  border-radius: 12px;
  margin: 0;
  padding: 24px;
  min-height: ${window.innerHeight - 55}px;
`;

const PageTitleStyled = styled.span`
  font-size: 20px;
  color: #1e293b;
  font-weight: 700;
`;

const DocumentNoStyled = styled.span`
  font-size: 18px;
  line-height: 20px;
  color: #1e293b;
  font-weight: 600;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: #1e293b;
  font-weight: 700;
`;

const SubTitleText = styled.span`
font-size: 14px;
color: #475569;
font-weight: 600;
line-height: 46px;
`;

const NormalText = styled(Text)`
  font-size: 14px;
  color: #64748b;
  line-height: 24px;
`;

// ใส่ .ant-divider-horizontal ด้วย ให้ selector ชนะ rule ของ antd (ไม่งั้นได้เส้น rgba(0,0,0,.06) ของ antd)
const DividerStyled = styled(Divider)`
  &.ant-divider-horizontal {
    margin: 32px 0;
    border-top-color: #f1f5f9;
  }
`;

const ButtonBackhual = styled(Button)`
height: 35px;
padding: 0 15px;
font-size: 16px;
`;

export {
  StyledSearchForm,
  GeneralStyledContent,
  DocumentNoStyled,
  TitleText,
  SubTitleText,
  PageTitleStyled,
  NormalText,
  DividerStyled,
  ButtonBackhual,
  StyledContent
};
